/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2018, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS 'AS IS' AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'
import { Query } from 'react-apollo'

import {
  Spinner,
  Warning
} from '../'

import {
  QUERY_IDENTITIES_BY_IDENTITYVALUE
} from '../../queries'

export class IdentityNumberSearch extends React.PureComponent {
  static propTypes = {
    idNumber: PropTypes.string.isRequired,
    render: PropTypes.func.isRequired  // returns identity found to the specified render function
  }

  render() {
    return (
      <Query
        query={QUERY_IDENTITIES_BY_IDENTITYVALUE}
        variables={{ identityValue: this.props.idNumber }}>
        {({ loading, error, data }) => {
          if (loading) {
            return <Spinner className='slds-is-relative slds-m-left_large' />
          }
          if (error) {
            return (
              <Warning className='slds-m-left_small'>
                Failed to initiate search for identity number.
              </Warning>
            )
          }

          let found = data.identities.edges.length > 0
          return this.props.render(found ? data.identities.edges[0].node : null)
        }}
      </Query>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/identity-number-search/index.js